// extracted by mini-css-extract-plugin
export default {"form":"listing-broker-account-statement_form__IlKmN"};